<template>
  <div>
    <topnav></topnav>
    <div class="conall">
        <div class="con flex justify-between">
            <div class="cleft">
                <div v-if="info" class="cavatar bg-white flex justify-center align-center flex-direction">
                    <el-image v-if="info.shop.shop_logo" class="cavatarimg" :src="info.shop.shop_logo | addurl" fit="fill"></el-image>
                    <el-image v-else class="cavatarimg" :src="info.avatar" fit="fill"></el-image>
                    <div class="margin-tb-sm text-cut2" style="color: #191919;font-size: 16px;padding: 0 15px;">{{info.shop.shop_name ? info.shop.shop_name : ''}}</div>
                    <div class="margin-tb-sm" style="color: #989898;font-size: 14px;">入驻时间：{{info.shop.createtime ? info.shop.createtime : ''}}</div>
                </div>
                <div class="response" style="background-color: #f4f4f4;height: 8px;"></div>
                <div class="" style="border-radius: 0 0 8px 8px;overflow: hidden;">
                    <div class="leftone flex justify-center align-center bg-white pointer" v-for="(item,index) in tablist" :key="index" @click="tochange(index,item.type,item.path)" :class="item.type == tabindex ? 'coloractive' : 'colorone'">
                        
                        <el-image v-if="item.type == tabindex" :src="item.icon2" style="width: 30px;height: 30px;margin-right: 20px;" fit="fill"></el-image>
                        <el-image v-else :src="item.icon1" style="width: 30px;height: 30px;margin-right: 20px;" fit="fill"></el-image>
                        <div>{{item.title}}</div>
                    </div>
                </div>
            </div>
            <div class="cright">
                <router-view></router-view>
            </div>
        </div>
    </div>
    
  </div>
</template>
<script>
import { mapGetters } from "vuex";
  import Tinymce from '@/components/Tinymce'
export default {
  computed: {
    ...mapGetters(["type","token"])
  },
  components: { Tinymce },
  data() {
    return {
        info:'',
        load: true,
        tablist: [{
            title: '企业服务',
            checked: true,
            type: 1,
            path: 'service',
            icon1: '/static/assets/images/icon/icon1.png',
            icon2: '/static/assets/images/icon/icon2.png'
        },{
            title: '房间费用',
            checked: false,
            type: 2,
            path: 'room_price',
            icon1: '/static/assets/images/icon/icon3.png',
            icon2: '/static/assets/images/icon/icon4.png'
        },{
            title: '服务费用',
            checked: false,
            type: 3,
            path: 'service_price',
            icon1: '/static/assets/images/icon/icon5.png',
            icon2: '/static/assets/images/icon/icon6.png'
        },{
            title: '缴费方式',
            checked: false,
            type: 4,
            path: 'payment_way',
            icon1: '/static/assets/images/icon/icon7.png',
            icon2: '/static/assets/images/icon/icon8.png'
        },{
            title: '服务记录',
            checked: false,
            type: 5,
            path: 'service_list',
            icon1: '/static/assets/images/icon/icon9.png',
            icon2: '/static/assets/images/icon/icon10.png'
        },{
            title: '企业简介',
            checked: false,
            type: 6,
            path: 'company_brief',
            icon1: '/static/assets/images/icon/icon11.png',
            icon2: '/static/assets/images/icon/icon12.png'
        },{
            title: '联系方式',
            checked: false,
            type: 7,
            path: 'concat_us',
            icon1: '/static/assets/images/icon/icon13.png',
            icon2: '/static/assets/images/icon/icon14.png'
        }],
        tabindex: 1,
        totalnum: 0,
        currentPage: 1,
        pagerCount: 7,
        roomlist: [],
        config: '',
        pagesize: 10,
        pagesizetwo: 5,
        totalnumnew: 0,
        currentPagenew: 1,
        zlist: [],
        content: '<p>123</p>',
        edit: 0,
        flist: [],
        totalnumtwo: 0,
        currentPagetwo: 1,
        pagef: 5,

        newlist: [],
        totals: 0,
        currents: 1,
        newpages: 5,


        
        newlisttwo: [],
        totalstwo: 0,
        currentstwo: 1,
        newpagestwo: 5
      
    };
  },
  watch:{
    $route (to, from, next) {
        console.log('1111111',to)
      if(to.path == '/personal'){
        this.$router.push({name: this.tablist[0].path})
        this.tabindex = 1
      }else{
        for(let i in this.tablist){
            if(to.path == '/personal/' + this.tablist[i].path){
                this.tabindex = i;
            }
        }
      }

      console.log('beforeRouteEnter',to.path)
    }
  },
  methods: {
      tonewdetailtwo(id){
        var data = {
            id: id,
            start: this.currentstwo,
            page_size: this.newpagestwo,
            type: 2
        }
        this.tabindex = 8;
        this.$api.index.my_record(data).then(res=>{
            console.log(res)
            this.newlisttwo = res.data;
            this.totalstwo = res.count;
            this.load = false;
        }).catch(res=>{
            // console.log(res,1111111111)
            this.load = false;
        })
    },
    curchangetwo(currentPage){
        this.currentstwo = currentPage;
        this.tonewdetailtwo();
    },
    schangetwo(){

    },
      tonewdetail(id){
        var data = {
            id: id,
            start: this.currents,
            page_size: this.newpages,
            type: 1
        }
        this.tabindex = 7;
        this.$api.index.my_record(data).then(res=>{
            console.log(res)
            this.newlist = res.data;
            this.totals = res.count;
            this.load = false;
        }).catch(res=>{
            // console.log(res,1111111111)
            this.load = false;
        })
    },
    backtwo(){
        this.roomlist = [];
        this.currentPage = 1;
        this.totalnum = 0;
        this.load = true;
        this.getmyroom();
        this.tabindex = 2;
    },
    backone(){
        this.flist = [];
        this.currentPagetwo = 1;
        this.load = true;
        this.totalnumtwo = 0;
        this.getflist();
        this.tabindex = 5;
    },
      tosubedit(){
          console.log(this.info.shop)
          if(!this.info.shop.content){
              this.$message.error('请输入内容')
              return false;
          }
          var data = {
              content: this.info.shop.content,
              id: this.info.shop.id
          }
          this.$api.index.intro_edit(data).then(res=>{
            console.log(res)
            this.$message.success(res.msg)
            this.edit = 0;
            this.getuserinfo();
        })
      },
    tochange(index,type,path){
        this.tabindex = type;
        this.$router.push({name: path})
        this.cIndex = index;
        return false;
        for(let i in this.tablist){
            this.tablist[i].checked = false;
        }
        this.tablist[index].checked = true;
        if(type == 2){
            this.roomlist = [];
            this.currentPage = 1;
            this.totalnum = 0;
            this.load = true;
            this.getmyroom();
        }else if(type == 4){
            this.zlist = [];
            this.currentPagenew = 1;
            this.totalnumnew = 0;
            this.load = true;
            this.getzlist();
        }else if(type == 5){
            this.flist = [];
            this.currentPagetwo = 1;
            this.load = true;
            this.totalnumtwo = 0;
            this.getflist();
        }
    },
    handleSizeChange(){

    },
    handleCurrentChange(currentPage){
        this.currentPage = currentPage;
        this.getmyroom();
    },
    handleSizeChangetwo(){

    },
    handleCurrentChangetwo(currentPage){
        this.currentPagetwo = currentPage;
        this.getflist();
    },
    curchange(currentPage){
        this.currents = currentPage;
        this.tonewdetail();
    },
    schange(){

    },
    getmyroom(){
        var data = {
            shop_id: this.info.shop.id,
            start: this.currentPage,
            page_size: this.pagesizetwo
        }
        this.$api.index.my_room(data).then(res=>{
            console.log(res)
            this.roomlist = res.data;
            this.totalnum = res.count;
            this.load = false;
        }).catch(res=>{
            // console.log(res,1111111111)
            this.load = false;
        })
    },
    getconfig(){
        this.$api.index.config().then(res=>{
            this.config = res.data;
        })
    },
    handleSizeChangenew(){

    },
    handleCurrentChangenew(currentPage){
        this.currentPagenew = currentPage;
        this.getzlist();
    },
    getzlist(){
        var data = {
            user_id: this.info.id,
            start: this.currentPagenew,
            page_size: this.pagesize
        }
        this.$api.index.my_question(data).then(res=>{
            this.zlist = res.data;
            this.totalnumnew = res.count;
            this.load = false;
        }).catch(res=>{
            // console.log(res,1111111111)
            this.load = false;
        })
    },
    getflist(){
        var data = {
            shop_id: this.info.shop.id,
            start: this.currentPagetwo,
            page_size: this.pagef
        }
        this.$api.index.my_ortherroom(data).then(res=>{
            this.flist = res.data;
            this.totalnumtwo = res.count;
            this.load = false;
        }).catch(res=>{
            // console.log(res,1111111111)
            this.load = false;
        })
    },
    getuserinfo(){
        var type = localStorage.getItem('type');
        if(type == 2){
            var types = 1;
        }else if(type == 1){
            var types = 2;
        }
        var data = {
            user_id: this.token,
            type: types
        }
        this.$api.user.userinfo(data).then(res=>{
            var data = res.data;
            var regex = new RegExp('<img','gi');
            var content = res.data.shop.content;
            if(content){
                res.data.shop.content = content.replace(regex,`<img style="max-width: 100%;height: auto"`)
            }
            this.info = data;
            var sdata = JSON.stringify(data)
            // this.$store.commit('SET_USERINFO',sdata)
            localStorage.setItem('userinfo', sdata)
        })
    }
  },
  created(){
    //   concat_us
      this.$router.push({name: 'service'});
      this.getuserinfo();
    this.getconfig();
  },
  beforeDestroy() {

  }
};
</script>
<style scoped>
    .newclass{
        width: 48%;border: 1px solid #eee;border-radius: 10px;
        /* box-shadow: 6px 6px 8px rgba(26, 26, 26, 0.2) */
    }
    .conall{
        width: 100%;
        min-height: 600px;
        background: #f4f4f4;
    }
    .con{
        width: 1320px;
        padding: 40px 0;
        margin: 0 auto;
    }
    .cleft{
        width: 307px;
        /* min-height: 440px; */
        border-radius: 4px;
    }
    .rtitle{
        padding: 20px;
        font-size: 16px;
        color: #7d7d7d;
        border-bottom: 8px solid #f4f4f4;
    }
    .cavatar{
        font-size: 14px;
        border-radius: 8px 8px 0 0;
        padding: 30px 0 20px 0;
    }
    .cavatarimg{
        width: 80px;height: 80px;border-radius: 50%;
    }
    .leftone{
        width: 100%;height: 70px;line-height: 70px;
        text-align: center;font-size: 16px;
        border-bottom: 1px solid #eee;
        position: relative;
    }
    .leftone:last-child{
        border-bottom: none;
    }
    .colorone{
        color: #666;
    }
    .coloractive{
        color: #1759d8;
    }
    .bg-white{
        background: #fff;
    }
    .cright{
        width: 984px;
        min-height: 440px;
        /* overflow: hidden; */
    }
    .center {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
    }
    .center:first-child{
        margin-top: 0px;
    }
    .right {
        width: 47%;
        background-color: #ffffff;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .left {
        font-size: 14px;
        color: #686868;
        margin-right: 18px;
        text-align: right;
        width: 60px;
    }
    .mall{
        margin-top: 50px;
    }
    .btn{
        border: 0;
        width: 300px;
        height: 38px;
        background-color: #ff7900;
        color: #fff;
        font-size: 16px;
        text-align: center;
        line-height: 38px;
        border-radius: 5px;
    }
    .editbtn{
        width: 92px;
        height: 34px;
        line-height: 34px;
        text-align: center;color: #fff;font-size: 16px;
        background-color: #1759d8;
        border-radius: 4px;
    }
    .colorleft{
        color: #191919;font-size: 20px;
    }
    .colorright{
        color: #7e7e7e;font-size: 18px;
    }
    .rowone{
        height: 60px;line-height: 60px;
    }
    .pleft{
        color: #a0a0a0;font-size: 18px;
    }
    .pright{
        padding-left: 45px;
        color: #151515;font-size: 18px;
    }
    .contact{
        height: 105px;
        line-height: 105px;
        border-bottom: 1px solid #eee;
        padding: 0 60px;
    }
    .cball{
        border-radius: 0 0 12px 12px;overflow:hidden;
    }
    .lastone{
        margin-bottom: 20px;
    }
    .lastone:last-child{
        margin-bottom: 0;
    }
    .rone{
        border-radius: 12px 12px 0 0;
    }
    .rtwo{
        border-radius: 12px;
    }
    .qrimg{
        /* height: 200px; */
        /* width: 400px; */
        width: 100%;
        margin-bottom: 15px;
        /* margin-right: 30px */
    }
    .qrimg:last-child{
        margin: 0
    }
    .newone{
        width: 90%;height: 50px;line-height: 50px;
    }
    .backbtn{
        width: 82px;
        height: 35px;
        line-height: 35px;
        background-color: #00c9bd;
        border-radius: 6px;
        color: #fff;font-size: 16px;
        position: absolute;
        top: 13px;left: 10px;
        text-align: center;
        cursor: pointer;z-index: 9999;
    }
</style>



// WEBPACK FOOTER //
// personal.vue?20de0416